export default "__VITE_ASSET__Ct6cpFaM__"